/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { Modal } from 'antd'

import Grid from '@integec/grid-tools/lib/Grid'
import {
  defaultVirtualizedCellRender,
  virtualizedGridRenderer,
} from '@integec/grid-tools'
import { rowHeaderRender } from 'core'

import {
  generateGridHeaderForMetaInfo,
  generateMetaInfoMap,
  getHeadersFromMap,
  getFootersFromMap,
} from './utils'
import { FullHeightSizer } from 'core/screen-util'

const gridCellRender = props => {
  const { rowIndex, columnIndex } = props.reactVirtualizedProps
  const { data, headers } = props.gridToolProps
  const rowData = data[rowIndex]
  const header = headers[columnIndex]
  const cellData = rowData[header.ident]

  if (cellData && cellData.color) {
    return defaultVirtualizedCellRender({
      ...props,
      backgroundColor: '#' + cellData.color,
      fontWeight: cellData.bold && 'bold',
    })
  }

  if (cellData && cellData.bold) {
    return defaultVirtualizedCellRender({
      ...props,
      fontWeight: 'bold',
    })
  }

  return defaultVirtualizedCellRender(props)
}

const MetaDataGrid = ({ data, headers, title, height, width }) => {
  return (
    <div
      style={{
        marginTop: 5,
        marginBottom: 2,
        borderBottom: 'solid lightgrey 1px',
        height: height,
      }}
    >
      <div>
        <h3>{title}</h3>
      </div>
      <Grid
        isEditable={false}
        sortEnabled={false}
        data={data}
        headers={headers}
        render={virtualizedGridRenderer({
          rowHeaderRender: rowHeaderRender,
          headerRowHeight: 30,
          cellRender: gridCellRender,
          width: width,
          height: height - 50,
        })}
      />
    </div>
  )
}

const ReportMetaModal = ({ metaInfo, hide }) => {
  const gridHeaders = generateGridHeaderForMetaInfo(metaInfo)
  const metaInfoMap = generateMetaInfoMap(metaInfo)
  const headers = getHeadersFromMap(metaInfoMap)
  const footers = getFootersFromMap(metaInfoMap)

  const onOk = () => {
    hide()
  }

  return (
    <Modal
      title="Report Meta Information"
      width="80vw"
      visible
      onOk={onOk}
      okText="Ok"
      onCancel={hide}
      centered
      maskClosable={false}
    >
      <FullHeightSizer heightOffset={300}>
        {({ height, width }) => (
          <div style={{ height: height }}>
            <MetaDataGrid
              title="Headers"
              data={headers}
              headers={gridHeaders}
              height={height / 2}
              width={width}
            />
            <div style={{ textAlign: 'center', border: '1px solid lightgrey' }}>
              <h3>Data</h3>
            </div>
            <MetaDataGrid
              title="Footers"
              data={footers}
              headers={gridHeaders}
              height={height / 2}
              width={width}
            />
          </div>
        )}
      </FullHeightSizer>
      <div style={{ height: 50 }} />
    </Modal>
  )
}

export default ReportMetaModal
